<template>
  <div>
    <van-form ref="form"  @failed="onFailed">
      <h4 class="cellSty">发票信息</h4>
      <van-field
        required
        v-model="dataname.companyName"
        name="发票抬头"
        label="发票抬头"
        placeholder="发票抬头"
        :rules="[{ required: true, message: '请填写发票抬头' }]"
      />
      <van-field
        required
        v-model="dataname.companyTax"
        name="单位税号"
        label="单位税号"
        placeholder="单位税号"
        :rules="[{ required: true, message: '请填写单位税号' }]"
      />

      <van-field
        v-model="dataname.taxAddress"
        name="注册地址"
        label="注册地址"
        placeholder="注册地址"
      />
      <van-field
        v-model="dataname.taxTel"
        name="注册电话"
        label="注册电话"
        placeholder="注册电话"
      />
      <van-field
        v-model="dataname.taxBank"
        name="开户银行"
        label="开户银行"
        placeholder="开户银行"
      />
      <van-field
        v-model="dataname.taxAccount"
        name="银行账号"
        label="银行账号"
        placeholder="银行账号"
      />
      <h4 class="cellSty">接收人信息</h4>
      <van-field
        required
        v-model="dataname.taxMail"
        name="邮箱"
        label="邮箱"
        placeholder="邮箱"
        :rules="[
          { required: true, message: '请输入邮箱' },
          { validator: validatorEmail, message: '邮箱格式有误' },
        ]"
      />
      <van-field
        required
        v-model="dataname.taxPhone"
        name="手机"
        label="手机"
        placeholder="手机"
        :rules="[
          { required: true, message: '请输入手机号' },
          { validator: validatorPhone, message: '手机号格式有误' },
        ]"
      />
      <!-- <van-cell-group> -->
      <van-cell title="是否设为默认">
        <van-switch v-model="checked" />
      </van-cell>
      <!-- </van-cell-group> -->
      <div style="margin: 16px" v-if="bool == 1">
        <van-button round block type="info" @click="submit"
          >提交</van-button
        >
      </div>

      <div v-if="bool == 2" class="editclass">
        <van-button type="info" @click.stop="ondeit">保存</van-button>
        <van-button class="tbn" @click="del">删除</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { ContactEdit, Toast, Form, Field, Button, Dialog, CellGroup, Switch, Cell } from 'vant';
import api from '@/api'

export default {
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Switch.name]: Switch,
    [Dialog.name]: Dialog,
    [ContactEdit.name]: ContactEdit,
    [Toast.name]: Toast,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
  },
  data() {
    return {
      dataname: {

        companyName: '',
        companyTax: '',
        taxAccount: '',
        taxBank: '',
        taxTel: '',
        taxAddress: '',
        taxPhone: '',
        taxMail: '',
      },
      filedname: [],
      checked: false,
      bool: null,

    };
  },
  created() {
    if (this.$route.params.nameorder == 'add') {
      this.bool = 1
      this.dataname = {
        companyName: '',
        companyTax: '',
        taxAccount: '',
        taxBank: '',
        taxTel: '',
        taxAddress: '',
        taxPhone: '',
        taxMail: '',
      }
    }
    if (this.$route.params.nameorder == 'edit') {

      this.bool = 2
      this.detial();
    }
    this.getPersonalQueryInvoice();
  },
  methods: {
    onFailed(val) {
      // console.log(val, '0-0-0-0');
      this.filedname = val.errors

    },
    ondeit() {
      this.$refs.form.validate().then(() => {
        let params = {
          id: this.$route.params.id,
          ...this.dataname,
        }
        api.train.invoicecreate(params).then(res => {
          if (res.code == 0) {
            this.$router.go(-1)
            this.$toast.success({
              message: '成功',
            })
          }
        })
      })



    },
    del() {
      let params = {
        id: this.$route.params.id,
      }
      Dialog.confirm({
        title: '标题',
        message: '您确认要删除吗？',
      })
        .then(() => {
          api.train.invoicedelete(params).then(res => {
            if (res.code == 0) {

              this.$router.go(-1)
            }
          })
        })
        .catch(() => {
          // on cancel
        });

    },
    submit(values) {
      this.$refs.form.validate().then(() => {

        let params = {
          ...this.dataname
        }
        api.train.invoicecreate(params).then(res => {
          if (res.code == 0) {
            this.$router.go(-1)
            this.$toast.success({
              message: '成功',
            })
          }
        })
      })
    },
    detial() {
      let params = { id: this.$route.params.id }
      api.train.invoicegetgetDes(params).then(res => {
        if (res.code == 0) {
          this.dataname = res.data
        }
      })
    },
    validatorPhone(val) {
      let reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/
      return reg.test(val);
    },
    validatorEmail(val) {
      let reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      return reg.test(val);
    },
    getPersonalQueryInvoice(){
      api.train.personalQueryInvoice().then(res =>{
        // console.log(res);
        this.dataname.companyName = res.data.supplierName;
        this.dataname.companyTax = res.data.supplierRegisterNo;
      })
    }
  },


}
</script>

<style lang="less" scoped>
.editclass {
  display: flex;
  justify-content: center;
  flex-direction:column ;
  /deep/.van-button {
    margin-top: 2em;
    border-radius: 2rem;
    flex: 1;
    margin: 1rem;
  }
  .tbn{
    margin-top:-0.5rem;
  }
}
.cellSty {
  color: #222;
  font-size: 0.9rem;
  margin-top: 1rem;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 2.66667vw 4.26667vw;
  overflow: hidden;
  color: #323233;
  background-color: #fff;
}
</style>